import { WarningOutlined } from "@ant-design/icons"
import { Flex, Tooltip, Typography } from "antd"

import { budgetFormat } from "../../../../../../../utils/number/budget-format.ts"
import type { ContractBreakdownSide } from "../../../../../types/project-finance.types.tsx"

const { Text } = Typography

interface ContractFigureProps {
  label: string
  value: number
  side?: ContractBreakdownSide | null
  alert?: { severity: "warning" | "critical"; message: string }
}

export function ContractFigure({
  label,
  value,
  side,
  alert
}: ContractFigureProps) {
  const original = side ? Number(side.original) : null
  const current = side ? Number(side.current) : null
  const hasBreakdown =
    original !== null && current !== null && original !== current

  const tooltip =
    hasBreakdown || alert ? (
      <Flex vertical gap={hasBreakdown && alert ? 6 : 0}>
        {hasBreakdown && side && (
          <Flex vertical>
            <Text className="text-white text-xs">
              Original {label}: {budgetFormat(original)}
            </Text>
            <Text className="text-white text-xs">
              Included Change Requests:{" "}
              {budgetFormat(Number(side.included_change_requests))}
            </Text>
            <Text className="text-white text-xs">
              Current {label}: {budgetFormat(current)}
            </Text>
          </Flex>
        )}
        {alert && (
          <Text className="text-white text-xs">{alert.message}</Text>
        )}
      </Flex>
    ) : null

  const line = (
    <Flex align="center" gap={6} className={tooltip ? "cursor-help" : undefined}>
      {alert && (
        <WarningOutlined
          className={
            alert.severity === "critical" ? "text-red-500" : "text-orange-500"
          }
          data-testid="contract-figure-warning"
          data-marker-for={label}
        />
      )}
      <Text>
        {label}: {budgetFormat(value)}
      </Text>
    </Flex>
  )

  return tooltip ? <Tooltip title={tooltip}>{line}</Tooltip> : line
}
